import { useEffect, useState } from 'react';
import { useDiscipleStore } from '../../../../store/discipleStore';
import { useMinistryTeamStore } from '../../../../store/ministryTeamStore';
import { getCounts } from './apis/disciple-apis';

export const Vision2028Progress = () => {
  const { disciples } = useDiscipleStore(); // 제자 리스트(구독)
  const { ministryTeams } = useMinistryTeamStore(); // 사역팀 리스트(구독)
  const [counts, setCounts] = useState({ disciplesCount: 0, ministryTeamsCount: 0 });

  /**
   * 제자나 사역팀이 추가/삭제될 때마다 전체 카운트를 다시 가져옴
   * : 제자와 사역팀 구독해서 변경 감지(disciples.length, ministryTeams.length)
   */
  useEffect(() => {
    getCounts().then(setCounts);
  }, [disciples.length, ministryTeams.length]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: '0.7em', color: '#999', fontFamily: '기본체' }}>
      [<span>제자: {counts.disciplesCount}/3000</span>
      <span>·</span>
      <span>사역팀: {counts.ministryTeamsCount}/1000</span>]
    </div>
  );
};
